import { useEffect, useState } from "react";
import { theme,Button } from "antd";
import { getBackendUrl } from "../../utils/env";
import axios from "axios";
import { FireFilled } from "@ant-design/icons";
import RankingShareCard from "./RankingShareCard";
import * as htmlToImage from "html-to-image";

/* ─── ESTILOS DINÁMICOS ───────────────────────────────────────────────────── */
const makeStyles = (t) => `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;600&display=swap');

  .ranking-root {
    font-family: 'DM Sans', sans-serif;
    background: ${t.colorBgLayout};
    min-height: 100vh;
    padding: 40px clamp(16px, 5vw, 48px);
  }

  .ranking-header {
    text-align: center;
    margin-bottom: 52px;
  }
  .ranking-header::after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background: ${t.colorPrimary};
    margin: 12px auto 0;
    border-radius: 2px;
  }
  .ranking-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: clamp(36px, 8vw, 64px);
    letter-spacing: 4px;
    color: #ffe000;
    line-height: 1;
    margin: 0;
  }
  .ranking-subtitle {
    color: ${t.colorTextTertiary};
    font-size: 13px;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-top: 6px;
  }

  /* ── Podio ── */
  .podium-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 48px;
  }
  .podium-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  .podium-card--first  { order: 2; }
  .podium-card--second { order: 1; }
  .podium-card--third  { order: 3; }

  .podium-avatar-wrap { position: relative; margin-bottom: 12px; }
  .podium-glow {
    position: absolute;
    inset: -8px;
    border-radius: 50%;
    filter: blur(14px);
    opacity: 0.45;
    pointer-events: none;
  }
  .podium-crown {
    position: absolute;
    top: -22px; left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    z-index: 2;
  }
  .podium-name {
    font-size: clamp(12px, 3vw, 14px);
    font-weight: 600;
    color: ${t.colorText};
    text-align: center;
    max-width: 90px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .podium-points {
    font-family: 'Bebas Neue', sans-serif;
    font-size: clamp(16px, 4vw, 20px);
    letter-spacing: 1px;
    margin-top: 2px;
  }
  .podium-block {
    width: 100%;
    border-radius: 12px 12px 0 0;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 22px;
    color: rgba(0,0,0,0.35);
    letter-spacing: 2px;
  }

  /* ── Tabla ── */
  .ranking-table-card {
    background: ${t.colorBgContainer};
    border: 1px solid ${t.colorBorderSecondary};
    border-radius: 16px;
    overflow: hidden;
  }
  .ranking-table-head {
    padding: 20px 24px;
    border-bottom: 1px solid ${t.colorBorderSecondary};
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .ranking-table-head-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 20px;
    letter-spacing: 3px;
    color: ${t.colorText};
    margin: 0;
  }
  .ranking-table-head-line {
    flex: 1;
    height: 1px;
    background: ${t.colorBorderSecondary};
  }

  .ranking-row {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    border-bottom: 1px solid ${t.colorBorderSecondary};
    transition: background 0.15s;
    gap: 16px;
  }
  .ranking-row:last-child { border-bottom: none; }
  .ranking-row:hover { background: ${t.colorFillAlter}; }
  .ranking-row--me {
    background: ${t.colorPrimaryBg} !important;
    border-bottom-color: ${t.colorPrimaryBorder} !important;
  }

  .rank-num {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 18px;
    color: ${t.colorTextTertiary};
    width: 36px;
    text-align: center;
    flex-shrink: 0;
  }
  .user-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }
  .user-name {
    font-size: 14px;
    font-weight: 500;
    color: ${t.colorText};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .user-name--me { color: ${t.colorPrimary}; font-weight: 600; }

  .me-pill {
    background: ${t.colorPrimaryBg};
    color: #ffe000;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 2px 7px;
    border-radius: 20px;
    border: 1px solid ${t.colorPrimaryBorder};
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .points-col {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 18px;
    letter-spacing: 1px;
    color: ${t.colorText};
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }
  .points-col--top { color: ${t.colorWarning}; }

  /* ── Skeleton shimmer ── */
  @keyframes shimmer {
    0%   { background-position: -600px 0; }
    100% { background-position:  600px 0; }
  }
  .skeleton {
    border-radius: 6px;
    background: linear-gradient(
      90deg,
      ${t.colorFillAlter} 25%,
      ${t.colorFillSecondary} 50%,
      ${t.colorFillAlter} 75%
    );
    background-size: 600px;
    animation: shimmer 1.4s infinite linear;
  }

  /* ── Animaciones ── */
  @keyframes riseIn {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .podium-card { animation: riseIn 0.5s ease both; }
  .podium-card--second { animation-delay: 0.1s; }
  .podium-card--first  { animation-delay: 0.2s; }
  .podium-card--third  { animation-delay: 0.3s; }

  @keyframes rowIn {
    from { opacity: 0; transform: translateX(-12px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  .ranking-row { animation: rowIn 0.35s ease both; }
`;

const exportRankingCard = async () => {
  const node = document.getElementById("ranking-share-card");

  const dataUrl = await htmlToImage.toPng(node, {
      pixelRatio: 3,
    cacheBust: true,
    useCORS: true,
  });

  const link = document.createElement("a");
  link.download = "ranking.png";
  link.href = dataUrl;
  link.click();
};


/* Colores de medalla — universales, no dependen del tema */
const MEDALS = {
  1: { color: "#FFD95A", glow: "#FFD95A", size: 84, blockH: 84 },
  2: { color: "#C8D6E5", glow: "#C8D6E5", size: 64, blockH: 56 },
  3: { color: "#E8A87C", glow: "#E8A87C", size: 56, blockH: 36 },
};

/* ─── COMPONENTE PRINCIPAL ────────────────────────────────────────────────── */
export default function Ranking() {
  const { token } = theme.useToken();
  const css = makeStyles(token);

  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);

  const requesterId = parseInt(localStorage.getItem("user_id"), 10) || null;

  const bravoColor = "#ffe000";

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const tkn = localStorage.getItem("token");
        const res = await axios.get(`${getBackendUrl()}api/ranking.php`, {
          headers: { Authorization: `Bearer ${tkn}` },
        });
        if (res.data.success) setRanking(res.data.ranking);
      } catch (err) {
        console.error("Error al cargar el ranking:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const topThree = ranking.slice(0, 3);
  const restOfRanking = ranking.slice(3);

  // orden visual: plata · oro · bronce
  const podiumOrder = [
    { user: topThree[1], rank: 2 },
    { user: topThree[0], rank: 1 },
    { user: topThree[2], rank: 3 },
  ];

  const myPosition =
    ranking.findIndex(
      (r) => String(r.id) === String(requesterId)
    ) + 1;

  const me = ranking.find(
    (r) => String(r.id) === String(requesterId)
  );

  return (
    <>
      <div style={{ position: "absolute", left: "-99999px" }}>
        <RankingShareCard
          me={me}
         ranking={ranking}
        />
      </div>
      <div className="ranking-root">
        <Button onClick={exportRankingCard} style={{ marginBottom: 24 }}>
          Compartir mi posición
        </Button>

        <style>{css}</style>

        <div className="ranking-header">
          <h1 className="ranking-title">Ranking</h1>
          <p className="ranking-subtitle">Tabla de líderes · Bravos</p>
        </div>

        {/* Podio */}
        {!loading && topThree.length > 0 && (
          <div className="podium-wrapper">
            {podiumOrder.map(({ user, rank }) => {
              if (!user) return null;
              return (
                <PodiumCard
                  key={user.id}
                  user={user}
                  rank={rank}
                  medal={MEDALS[rank]}
                  isMe={String(user.id) === String(requesterId)}
                  token={token}
                />
              );
            })}
          </div>
        )}

        {/* Tabla */}
        <div className="ranking-table-card">
          <div className="ranking-table-head">
            <h2 className="ranking-table-head-title">Más Dinamicos</h2>
            <div className="ranking-table-head-line" />
          </div>

          {loading ? <SkeletonRows /> : restOfRanking.map((record, idx) => {
            const isMe = String(record.id) === String(requesterId);
            const isTop = idx < 2;
            return (
              <div
                key={record.id}
                className={`ranking-row${isMe ? " ranking-row--me" : ""}`}
                style={{ animationDelay: `${idx * 0.04}s` }}
              >
                <span className="rank-num">#{idx + 4}</span>

                <div className="user-info">
                  <UserAvatar user={record} size={34} borderColor={token.colorBorderSecondary} token={token} />
                  <span className={`user-name${isMe ? " user-name--me" : ""}`}>{record.name}</span>
                  {isMe && <span className="me-pill">Tú</span>}
                </div>

                <span className={`points-col${isTop ? " points-col--top" : ""}`}>
                  {isTop && <FireFilled style={{ fontSize: 14 }} />}
                  {record.points.toLocaleString()} B
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

/* ─── Podium Card ──────────────────────────────────────────────────────────── */
function PodiumCard({ user, rank, medal, isMe, token }) {
  const rankClass = rank === 1 ? "first" : rank === 2 ? "second" : "third";
  return (
    <div className={`podium-card podium-card--${rankClass}`}>
      <div className="podium-avatar-wrap">
        {rank === 1 && <span className="podium-crown">👑</span>}
        <div className="podium-glow" style={{ background: medal.glow }} />
        <UserAvatar user={user} size={medal.size} borderColor={medal.color} token={token} />
      </div>
      <span className="podium-name">{user.name}{isMe ? " · Tú" : ""}</span>
      <span className="podium-points" style={{ color: medal.color }}>
        {user.points.toLocaleString()} B
      </span>
      <div
        className="podium-block"
        style={{ height: medal.blockH, background: medal.color, width: medal.size + 24 }}
      >
        {rank}
      </div>
    </div>
  );
}

/* ─── Avatar ──────────────────────────────────────────────────────────────── */
function UserAvatar({ user, size, borderColor, token }) {
  const src = user.profile_picture ? `${getBackendUrl()}${user.profile_picture}` : null;
  const commonStyle = {
    width: size, height: size,
    borderRadius: "50%",
    border: `3px solid ${borderColor}`,
    flexShrink: 0,
    display: "block",
  };

  return src ? (
    <img src={src} alt={user.name} style={{ ...commonStyle, objectFit: "cover" }} />
  ) : (
    <div style={{
      ...commonStyle,
      background: token?.colorFillAlter,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.38,
      color: token?.colorTextTertiary,
      fontWeight: 600,
    }}>
      {user.name?.[0]?.toUpperCase() ?? "?"}
    </div>
  );
}

/* ─── Skeleton ────────────────────────────────────────────────────────────── */
function SkeletonRows() {
  return Array.from({ length: 6 }).map((_, i) => (
    <div key={i} className="ranking-row" style={{ gap: 16 }}>
      <div className="skeleton" style={{ width: 28, height: 18 }} />
      <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1 }}>
        <div className="skeleton" style={{ width: 34, height: 34, borderRadius: "50%" }} />
        <div className="skeleton" style={{ width: "45%", height: 14 }} />
      </div>
      <div className="skeleton" style={{ width: 52, height: 18 }} />
    </div>
  ));

}
